import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/controlsPause.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...n,
	children: [/* @__PURE__ */ e("path", {
		fill: "#1f2830",
		d: "M3 1h7v22H3z"
	}), /* @__PURE__ */ e("path", {
		fill: "#1f2830",
		d: "M14 1h7v22h-7z"
	})]
});
//#endregion
export { n as default };
